import React, { useState, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { MBooking } from '../types'
import { BOOKING, BookingContext } from './BookingContext'
import { fetchBookingsAction } from '../helpers/bookingHelper'

const escapeRegexCharacters = str => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

const BookingBar = () => {
  const { state, dispatch } = useContext(BookingContext)
  const [value, setValue] = useState("")
  const [searchTimeout, setSearchTimeout] = useState(undefined)

  const handleChange = (event) => {
    setValue(event.currentTarget.value)
    getSuggestions(event.currentTarget.value)
  }

  const getSuggestions = value => {
    if (typeof searchTimeout === 'number') {
      window.clearTimeout(searchTimeout)
    }
    let timeOutVal = window.setTimeout(() => {
      fetchBookingsAction(dispatch, 1, escapeRegexCharacters(value.trim()))
    }, 500)
    setSearchTimeout(timeOutVal)
  }

  return (
    <div className="search-bar bookings-filter">
      <label className="fuzzy">
        <span>Search:</span>
        <input type="text"
          value={value}
          onChange={handleChange}
          placeholder="By Status, Hotel, Name, Tour ID or Date (mm/dd/yyyy)" />
      </label>
    </div>
  )
}

export default BookingBar
